/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SettingsSlidersH2Icon24Solid = forwardRef('SettingsSlidersH2Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M21 5.875h-2.422a3.752 3.752 0 0 0-7.156 0H3a1.125 1.125 0 0 0 0 2.25h8.422a3.752 3.752 0 0 0 7.156 0H21a1.125 1.125 0 0 0 0-2.25Z" }),
        React.createElement("path", { d: "M3 15.875a1.125 1.125 0 0 0 0 2.25h2.422a3.752 3.752 0 0 0 7.156 0H21a1.125 1.125 0 0 0 0-2.25h-8.422a3.752 3.752 0 0 0-7.156 0H3Z" })));
});
